module.exports = {
    OriginPath:'https://avmc.onrender.com'
}
